export default "__VITE_ASSET__BF4ocdfn__"